import axios from "axios";
import store from "../store";
import { fetchPendingTerms } from "./organization/actions";

let axiosInstance;

const isTermsEndpoint = (url) =>
  typeof url === "string" && url.startsWith("/api/terms/");

export const getLoginRedirectPath = () => {
  const t =
    typeof window !== "undefined" &&
    window.localStorage &&
    window.localStorage.getItem("loginType");
  return t === "employee" ? "/login-employee" : "/login";
};

const isOnLoginPage = () => {
  const p = window.location.pathname.toLowerCase();
  return (
    p === "/login" ||
    p === "/login-employee" ||
    p.startsWith("/admin-panel/login")
  );
};

export const refreshAxios = () => {
  axiosInstance = axios.create({
    // baseURL: 'https://some-domain.com/api/',
    // timeout: 1000,
    headers: {
      "x-tenantid-1": "main",
      // ...token ? {'X-Auth-Token': token} : {},
    },
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      const termsHeader = response.headers?.["x-terms-status"];
      if (
        termsHeader === "TERMS_NOT_ACCEPTED" &&
        !isTermsEndpoint(response.config?.url)
      ) {
        store.dispatch(fetchPendingTerms());
      }
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 403) {
        const code = error.response.data?.code;
        const termsHeader = error.response.headers?.["x-terms-status"];
        if (
          code === "TERMS_NOT_ACCEPTED" ||
          termsHeader === "TERMS_NOT_ACCEPTED"
        ) {
          if (
            window.location.pathname !== "/terms-accept" &&
            !isOnLoginPage()
          ) {
            window.location.href = "/terms-accept";
          }
        }
      }
      // A 401 from the change-password endpoint means "wrong current password",
      // not an expired session - keep the user on the page so the form can show
      // an inline error instead of redirecting to login.
      const isChangePassword = error.config?.url?.includes(
        "/api/auth/change_password"
      );
      if (
        error.response &&
        error.response.status === 401 &&
        !isOnLoginPage() &&
        !isChangePassword
      ) {
        window.location.href = getLoginRedirectPath();
      }
      return Promise.reject(error);
    }
  );
};

export const getAxiosInstance = () => {
  return axiosInstance;
};
